import React from 'react';
import { StyledImageContainer } from './Image.styled';
import { NextImg } from '../../atoms/NextImg';
import { StyledContentContainer } from '../../containers/StyledContentContainer.styled';
import { jsx as _jsx } from "react/jsx-runtime";
const PLACEHOLDER_IMAGE = '<svg fill="none" height="336" viewBox="0 0 584 336" width="584" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h584v336h-584z" fill="#425ccd" fill-opacity=".12"/><rect fill="#fff" fill-opacity=".5" height="72" rx="8" width="72" x="256" y="131"/><path clip-rule="evenodd" d="m303.667 152h-23.334c-1.833 0-3.333 1.5-3.333 3.333v23.334c0 1.833 1.5 3.333 3.333 3.333h23.334c1.833 0 3.333-1.5 3.333-3.333v-23.334c0-1.833-1.5-3.333-3.333-3.333zm0 3.333v23.334h-23.334v-23.334zm-13.1 17.884 5-6.45 6.433 8.566h-20l5-6.433z" fill="#000" fill-opacity=".6" fill-rule="evenodd"/></svg>';
const placeholderDataUri = `data:image/svg+xml;utf8,${encodeURIComponent(PLACEHOLDER_IMAGE)}`;
/**
 * The `Image` content block allows the user to place/edit images.
 *
 * Image Block is responsive based on a percentage of the
 * containing parent's width.
 * The user only sets the `responsiveWidth` prop in builder via a slider.
 * The prop value should be a number from 0-100.
 * This value is then turned into a percentage width.
 * Width and Height is set by our image-picker-library component.
 * The browser uses these values to
 * keep our cumulative layout shift (CLS) score low.
 *
 * ***Note*** that Image defaults to using a traditional `<img>` tag.
 * But in WHAMMY! it uses Next.js `<Image />` optimization helper.
 * More info can be found on the children prop description below.
 */
export const Image = _ref => {
  let {
    children,
    src,
    alt = '',
    alignXPreset,
    width = 0,
    height = 0,
    cssImageOpacity,
    responsiveWidth,
    cssOverlayColor,
    cssOverlayColorOpacity,
    cssBorderColor,
    cssBorderWidth,
    cssBorderRadius,
    fit = false,
    NextImage,
    parentLayoutInfo,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(StyledContentContainer, {
    fit: fit,
    parentLayoutInfo: parentLayoutInfo,
    children: /*#__PURE__*/_jsx(StyledImageContainer, {
      "data-id": "cp-image",
      cssOverlayColor: cssOverlayColor,
      cssOverlayColorOpacity: cssOverlayColorOpacity,
      alignXPreset: alignXPreset,
      cssImageOpacity: cssImageOpacity,
      cssBorderColor: cssBorderColor,
      cssBorderWidth: cssBorderWidth,
      cssBorderRadius: cssBorderRadius,
      responsiveWidth: responsiveWidth,
      children: /*#__PURE__*/_jsx(NextImg, {
        NextImage: NextImage,
        src: src || placeholderDataUri,
        alt: alt,
        width: width,
        height: height,
        ...rest
      })
    })
  });
};